import { makeTranslatable, rewriteVariables } from "../utils";
import { logo2 } from "../logo/logo2";
import { image1 } from "../images/image1";

const LABEL = "header1";

export const header1 = ({ logoUrl, imageUrl, shopUrl, headerColor  }) => ({
  label: LABEL,
  block: () => {

    const logo2Block = logo2({ logoUrl: makeTranslatable(logoUrl), href: makeTranslatable(shopUrl), alt: makeTranslatable(""), backgroundColor: headerColor }).block();
    const image1Block = image1({ imageUrl: makeTranslatable(imageUrl), href: makeTranslatable(shopUrl), alt: makeTranslatable(""), backgroundColor: headerColor }).block();

    const { variables: image1Variables, mjml: image1Mjml } = rewriteVariables("image1", image1Block.attributes.variables, image1Block.content.replaceAll("data-gjs=\"kilibaBlock\"", `data-gjs="kilibaBlock" data-blocklabel="${image1Block.label}"`) );

    const mjml = `
      ${logo2Block.content.replaceAll("data-gjs=\"kilibaBlock\"", `data-gjs="kilibaBlock" data-blocklabel="${logo2Block.label}"`)}
      ${image1Mjml}
    `;

    return {
      id: LABEL,
      label: LABEL,
      category: "header:subHeader",
      activate: true,
      content: mjml,
      attributes: {
        variables: {
          ...logo2Block.attributes.variables,
          ...image1Variables,
        }
      }
    };
  },
});